module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nc-appbar",
    staticStyle: {
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "nc-appbar-tabs"
  }, [(_vm.isLogin) ? _c('div', {
    staticClass: "ever"
  }, [_c('div', {
    staticClass: "cart"
  }, [_c('div', {
    staticClass: "num cart-num",
    staticStyle: {
      "top": "5px",
      "left": "-8px"
    }
  }, [_vm._v(_vm._s(_vm.cartNums))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.toCart()
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "name"
  }), _vm._v(" "), _c('i', {
    staticClass: "new_msg",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "myfavorite"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/favorite?status=1"
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "tit"
  }, [_vm._v("我的收藏")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.onlinePay(0)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "tit"
  }, [_vm._v("我的账户")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "variation"
  }, [_c('div', {
    staticClass: "middle"
  }, [(_vm.isLogin) ? _c('div', {
    staticClass: "user"
  }, [_c('router-link', {
    attrs: {
      "to": "/member/member"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.getters.face,
      "height": "120",
      "width": "120"
    }
  })])])], 1) : _c('div', {
    staticClass: "user"
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/default_face.jpg",
      "height": "120",
      "width": "120"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tit"
  }, [_vm._v("会员登录")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gotop",
    on: {
      "click": _vm.goTop
    }
  }, [_vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "icon"
  }), _c('span', {
    staticClass: "tit"
  }, [_vm._v("返回顶部")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe68848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/layout/sidebar.vue
// module id = 1584
// module chunks = 1